import Vue from "vue";

let keyTitle = "jns_mes_";

function clear() {
  removeData("userArr");
  removeData("deviceArr");
  removeData("orderColumnSettingArr");
  removeData("partColumnSettingArr");
  removeData("processColumnSettingArr");
  removeData("classifyMap");
  removeData("baseOrderPlanList");
  removeData("shelfMap");
  removeData("craftsArr");
  removeData("groupArr");
  removeData("fileClassifyArr");
  removeData("customerArray");
  removeData("matArr");
  removeData("unitArr");
  removeData("queryOrder");
  removeData("sotreArr");
  removeData("locationArr");
}

/**
 * 获取全部员工
 * @param func
 */
function getUserList(func) {
  let userArr = getDate("userArr");
  if (userArr) {
    func.call(Vue, userArr);
  } else {
    Vue.prototype.$get("/mes/system/user/list", {}, function(dataList) {
      userArr = dataList;
      saveData("userArr", userArr);
      func.call(Vue, userArr);
    });
  }
}
function getUserListbyDept(func) {
  let userArr = getDate("userDeptArr");
  if (userArr) {
    func.call(Vue, userArr);
  } else {
    Vue.prototype.$get("/mes/system/user/listByDpt", {}, function(dataList) {
      userArr = dataList;
      saveData("userDeptArr", userArr);
      func.call(Vue, userArr);
    });
  }
}

function clearUserList() {
  removeData("userArr");
}

/**
 * 获取生产工单列设定
 * @param func
 */
function getOrderColumnSetting(func) {
  let orderColumnSettingArr = getDate("orderColumnSettingArr");

  Vue.prototype.$get("/mes/order/column/json", {}, dataList => {
    orderColumnSettingArr = dataList;
    saveData("orderColumnSettingArr", orderColumnSettingArr);
    func.call(Vue, orderColumnSettingArr);
  });
}

function clearOrderColumnSetting() {
  removeData("orderColumnSettingArr");
}

/**
 * 获取零件类设定
 * @param func
 */
function getPartColumnSetting(func) {
  let partColumnSettingArr = getDate("partColumnSettingArr");
  if (partColumnSettingArr) {
    func.call(Vue, partColumnSettingArr);
  } else {
    Vue.prototype.$get("/mes/process/partColumn/json", {}, dataList => {
      partColumnSettingArr = dataList;
      saveData("partColumnSettingArr", partColumnSettingArr);
      func.call(Vue, partColumnSettingArr);
    });
  }
}

function clearPartColumnSetting() {
  removeData("partColumnSettingArr");
}

/**
 * 获取工序类设定
 * @param func
 */
function getProcessColumnSetting(func) {
  let processColumnSettingArr = false;
  if (processColumnSettingArr) {
    func.call(Vue, processColumnSettingArr);
  } else {
    Vue.prototype.$get("/mes/process/processColumn/json", {}, dataList => {
      processColumnSettingArr = dataList;
      saveData("processColumnSettingArr", processColumnSettingArr);
      func.call(Vue, processColumnSettingArr);
    });
  }
}

function clearProcessColumnSetting() {
  removeData("processColumnSettingArr");
}

/**
 * 获取分类设定
 * @param class_id 分类ID
 * @param func
 */
function getClassifyList(class_id, func) {
  let classifyMap = getDate("classifyMap");
  console.log(classifyMap, "classifyMap");
  if (classifyMap && classifyMap[class_id]) {
    func.call(Vue, classifyMap[class_id]);
  } else {
    Vue.prototype.$get(
      "/mes/system/classify/json",
      { class_id: class_id },
      function(dataList) {
        if (!classifyMap) {
          classifyMap = new Object();
        }
        classifyMap[class_id] = dataList;
        saveData("classifyMap", classifyMap);
        func.call(Vue, dataList);
      }
    );
  }
}

/**
 * 清除分类设定
 * @param class_id
 */
function clearClassify(class_id) {
  let classifyMap = getDate("classifyMap");
  if (classifyMap && classifyMap[class_id]) {
    delete classifyMap[class_id];
    saveData("classifyMap", classifyMap);
  }
}

/**
 * 获取设备列表
 * @param func
 */
function getDeviceList(func) {
  let deviceArr = getDate("deviceArr");
  Vue.prototype.$get("/mes/system/basic/device/list", {}, function(dataList) {
    deviceArr = dataList;
    saveData("deviceArr", deviceArr);
    func.call(Vue, dataList);
  });
}

function clearDeviceList() {
  removeData("deviceArr");
}

/**
 * 获取生产工单主计划节点列表-基础资料
 * @returns {*}
 */
function getBaseOrderPlanList(func) {
  let orderPlanList = getDate("baseOrderPlanList");
  if (orderPlanList) {
    func.call(Vue, orderPlanList);
  } else {
    Vue.prototype.$get("/mes/orderPlan/list", {}, function(dataList) {
      orderPlanList = dataList;
      saveData("baseOrderPlanList", orderPlanList);
      func.call(Vue, dataList);
    });
  }
}

function clearBaseOrderPlanList() {
  removeData("baseOrderPlanList");
}

/**
 * 获取基础资料-工艺列表
 * @param func
 */
function getCraftsList(func) {
  let craftsArr = getDate("craftsArr");

  Vue.prototype.$get("/mes/system/basic/crafts/list", {}, function(dataList) {
    craftsArr = dataList;
    saveData("craftsArr", craftsArr);
    func.call(Vue, craftsArr);
  });
}

function clearCrafts() {
  removeData("craftsArr");
}

/**
 * 获取货架列表
 * @param groupId 作业组ID
 * @param func
 */
function getShelfList(groupId, func) {
  let shelfMap = getDate("shelfMap");
  if (shelfMap && shelfMap[groupId]) {
    func.call(Vue, shelfMap[groupId]);
  } else {
    Vue.prototype.$get(
      "/mes/system/basic/shelf/list",
      { groupId: groupId },
      function(dataList) {
        if (!shelfMap) {
          shelfMap = new Object();
        }
        shelfMap[groupId] = dataList;
        saveData("shelfMap", shelfMap);
        func.call(Vue, dataList);
      }
    );
  }
}

/**
 * 清空货架缓存
 */
function clearShelves() {
  removeData("shelfMap");
}

/**
 * 获取作业组
 * @param func
 */
function getGroupList(func) {
  let groupArr = getDate("groupArr");
  if (groupArr) {
    func.call(Vue, groupArr);
  } else {
    Vue.prototype.$get("/mes/system/basic/group/list", {}, function(dataList) {
      groupArr = dataList;
      saveData("groupArr", groupArr);
      func.call(Vue, dataList);
    });
  }
}

function clearGroupList() {
  removeData("groupArr");
}

/**
 * 获取文件分类
 * @param type 传入0，获取全部数据，否则：1:生产工单;2:零件;3:工序
 * @returns {*}
 */
function getFileClassifyList(type, func) {
  let fileClassifyArr = getDate("fileClassifyArr");
  if (fileClassifyArr) {
    func.call(
      Vue,
      fileClassifyArr.filter(item => {
        return type == 0 ? true : item.respective_region == type;
      })
    );
  } else {
    Vue.prototype.$get("/mes/system/offline/file/classify/list", {}, function(
      dataList
    ) {
      fileClassifyArr = dataList;
      saveData("fileClassifyArr", fileClassifyArr);
      func.call(
        Vue,
        fileClassifyArr.filter(item => {
          return type == 0 ? true : item.respective_region == type;
        })
      );
    });
  }
}

/**
 * 获取客户列表
 */
function getCustomerList(func) {
  let customerArray = getDate("customerArray");
  if (customerArray) {
    func.call(Vue, customerArray);
  } else {
    Vue.prototype.$get("/mes/system/basic/custom/list", {}, function(dataList) {
      customerArray = dataList;
      saveData("customerArray", customerArray);
      func.call(Vue, dataList);
    });
  }
}

function getMatList(func) {
  let matArr = getDate("matArr");
  if (matArr) {
    func.call(Vue, matArr);
  } else {
    Vue.prototype.$get("/mes/process/part/getMatList", {}, function(dataList) {
      matArr = dataList;
      saveData("matArr", matArr);
      func.call(Vue, dataList);
    });
  }
}

function getUnitList(func) {
  let unitArr = getDate("unitArr");
  if (unitArr) {
    func.call(Vue, unitArr);
  } else {
    Vue.prototype.$get("/mes/system/basic/unit/list", {}, function(dataList) {
      unitArr = dataList;
      saveData("unitArr", unitArr);
      func.call(Vue, dataList);
    });
  }
}

function clearCustomerList() {
  removeData("customerArray");
}

function clearFileClassifyList() {
  removeData("fileClassifyArr");
}

function getOutsideFactoryList(func) {
  let outsideFactoryArr = getDate("outsideFactoryArr");
  if (outsideFactoryArr) {
    func.call(Vue, outsideFactoryArr);
  } else {
    Vue.prototype.$get("/mes/system/basic/outsideFactory/list", {}, function(
      dataList
    ) {
      outsideFactoryArr = dataList;
      saveData("outsideFactoryArr", outsideFactoryArr);
      func.call(Vue, dataList);
    });
  }
}
//获取仓别
function getStoreList(func) {
  let storeArray = getDate("sotreArr");
  if (storeArray) {
    func.call(Vue, storeArray);
  } else {
    Vue.prototype.$post(
      "/mes/system/basic/store/findAllStoreList",
      { pid: 0 },
      function(dataList) {
        storeArray = dataList;
        saveData("sotreArr", storeArray);
        func.call(Vue, dataList);
      }
    );
  }
}
//获取库位
function getLocationList(func) {
  let locationArray = getDate("locationArr");
  if (locationArray) {
    func.call(Vue, locationArray);
  } else {
    Vue.prototype.$post(
      "/mes/system/basic/store/findAllLocationList",
      {},
      function(dataList) {
        locationArray = dataList;
        saveData("locationArr", locationArray);
        func.call(Vue, dataList);
      }
    );
  }
}
function clearStoreList(pid) {
  removeData("sotreArr");
}
function clearLocationList() {
  removeData("locationArr");
}
function clearOutsideFactoryList() {
  removeData("outsideFactoryArr");
}

export default {
  clear,
  getUserList,
  clearUserList,
  getUserListbyDept,
  getDeviceList,
  clearDeviceList,
  getOrderColumnSetting,
  clearOrderColumnSetting,
  getPartColumnSetting,
  clearPartColumnSetting,
  getProcessColumnSetting,
  clearProcessColumnSetting,
  getClassifyList,
  clearClassify,
  getBaseOrderPlanList,
  clearBaseOrderPlanList,
  getShelfList,
  clearShelves,
  getCraftsList,
  clearCrafts,
  getGroupList,
  clearGroupList,
  getFileClassifyList,
  clearFileClassifyList,
  getCustomerList,
  clearCustomerList,
  getMatList,
  getUnitList,
  getOutsideFactoryList,
  clearOutsideFactoryList,
  getStoreList,
  getLocationList,
  clearStoreList,
  clearLocationList
};

function getDate(title) {
  let key = keyTitle + title;
  let val = sessionStorage.getItem(key);
  let json = null;
  if (val) {
    try {
      json = JSON.parse(val);
    } catch (e) {
      json = null;
    }
  }
  return json;
}

function saveData(title, json) {
  let key = keyTitle + title;
  if (json && Array.isArray(json)) {
    sessionStorage.setItem(key, JSON.stringify(json));
  } else {
    removeData(title);
  }
}

function removeData(title) {
  let key = keyTitle + title;
  sessionStorage.removeItem(key);
}



// WEBPACK FOOTER //
// ./src/common/DataStorage.js